import React, { useDeferredValue, useEffect, useState } from 'react';
import { useToaster, Message } from 'rsuite';
import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'



export function APIKey() {
    return "1cb5ba74-9d4f-4217-b35c-f00355a2b3ab";
}


export function ApiRoute() {
    // return "http://localhost:51391/api";
     return "https://api.farmasan.ir/api";
}





export function ApiPhotoRoute() {
   // return "http://localhost:51391/";
     return "https://api.farmasan.ir/";
}

export function customOptionsFilterMethod(filter, row) {

    if (filter.value != "")
        return (row[filter.id].toString().toLowerCase().toPersianDigit().includes(filter.value.toString().toLowerCase().toPersianDigit()));
    else
        return (row[filter.id].toLowerCase().includes(filter.value.toLowerCase()));
}


export function GuidEmpty() {
    return "00000000-0000-0000-0000-000000000000";
}



export function ShowMessage(type, msg) {
    return (   
        <Message showIcon type={type} closable>
            {msg}
        </Message>
    )
}


export const SuccessMessage = (Result) => {
    return (
        "داده ها با موفقیت " + Result
    )
}


export const ErrorMessage = (Result) => {
    if (String(Result) === "AccessDenied") {
        return ("دسترسی غیر مجاز ، لطفا با مدیر سیستم تماس بگیرید!");
    }
    else if (String(Result) === "InvalidApiKey") {
        return ("دسترسی غیر مجاز ، لطفا با مدیر سیستم تماس بگیرید!");
    }
    else {
        return (
            "خطای نامشخص ، شرح خطا    : " + Result
        )
    }
}




